import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFileIf, requiredFiles } from '../../useValidateQuestionnaire';
import {
  HomeSaleStateValues,
  TFixingUpExpensesDoneWithin90DaysOfDateOfSaleItem,
  TImprovementsToPropoertyItem,
  TSaleExpensesItem,
  TStHomeSale,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  | keyof HomeSaleStateValues
  | keyof TStHomeSale
  | keyof TFixingUpExpensesDoneWithin90DaysOfDateOfSaleItem
  | keyof TSaleExpensesItem
  | keyof TImprovementsToPropoertyItem
>[] = [
  {
    name: 'StHomeSaleList',
    label: 'Home Sale List',
    // type: 'record',
    type: 'fieldArray',
    tooltip: '',
    comment: true,
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    defaultDependency: {
      propertyAddress: null,
      propertyCountry: null,
      dateOfSale: null,
      salePricegross: null,
      originalPurchasePrice: null,
      foreignTaxPaidOnCapitalGainsFormPropertySale: null,
      datePropertyPurchased: null,
      improvementsToPropoerty: [
        { description: null, date: null, amount: null },
      ],
      fixingUpExpensesDoneWithin90DaysOfDateOfSale: [
        { description: null, date: null, amount: null },
      ],
      saleExpenses: [{ description: null, date: null, amount: null }],
      yearInWhichTheTaxWasActuallyPaid: null,
      wasThePropertyJointlyOwnedWithYourSpouse: null,
      hasThePropertyBeenOccupiedByYouAsYourMainResidenceForAtLeastTwoOutOfTheFiveYearsPriorToTheSale:
        null,
      hasThePropertyBeenRentedForAnyPeriodBetweenDecember312008AndTheSaleDate:
        null,
      isThePropertyInTheUs: null,
    },
    dependencies: [
      {
        name: 'propertyAddress',
        label: 'Property Address',
        type: 'textarea',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'propertyCountry',
        label: 'Property Country',
        type: 'country',
        placeholder: 'Select Country',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'dateOfSale',
        label: 'Date of Sale',
        subLabel: () => <p>Date of Completion in the UK</p>,
        type: 'date',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Select Date',
      },
      {
        name: 'salePricegross',
        label: 'Sale Price (Gross)',
        type: 'currency',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'originalPurchasePrice',
        label: 'Original Purchase Price',
        type: 'currency',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'foreignTaxPaidOnCapitalGainsFormPropertySale',
        label: 'Foreign tax paid on capital gains form property sale',
        type: 'currency',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'datePropertyPurchased',
        label: 'Date Property Purchased',
        type: 'date',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Select Date',
      },
      {
        name: 'improvementsToPropoerty',
        label: 'Improvements to Propoerty',
        type: 'fieldArray',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          description: null,
          date: null,
          amount: null,
        },
        dependencies: [
          {
            name: 'description',
            label: 'Description',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'date',
            label: 'Date',
            type: 'date',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Select Date',
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'fixingUpExpensesDoneWithin90DaysOfDateOfSale',
        label: 'Fixing up expenses done within 90 days of date of sale',
        type: 'fieldArray',
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        tooltip: '',
        comment: true,
        defaultDependency: {
          description: null,
          date: null,
          amount: null,
        },
        dependencies: [
          {
            name: 'description',
            label: 'Description',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter...',
          },
          {
            name: 'date',
            label: 'Date',
            type: 'date',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Select Date',
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'yearInWhichTheTaxWasActuallyPaid',
        label: 'Year in which the tax was actually paid',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter...',
      },
      {
        name: 'saleExpenses',
        label: 'Sale Expenses',
        type: 'fieldArray',
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        tooltip: '',
        comment: true,
        defaultDependency: {
          description: null,
          date: null,
          amount: null,
        },
        dependencies: [
          {
            name: 'description',
            label: 'Description',
            type: 'text',
            tooltip: '',
            comment: true,
            placeholder: 'Enter...',
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'date',
            label: 'Date',
            type: 'date',
            tooltip: '',
            comment: true,
            placeholder: 'Select Date',
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'wasThePropertyJointlyOwnedWithYourSpouse',
        label: 'Was the property jointly owned with your spouse?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'asYouAreNotFilingJointlyWhoWillBeResponsibleForTheGainOrLoss',
            label:
              'As you are not filing jointly, who will be responsible for the gain or loss?',
            options: [
              { label: 'Myself', value: 'Myself' },
              { label: 'Spouse', value: 'Spouse' },
              { label: 'Split', value: 'Split' },
            ],
            type: 'select',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
        ],
      },
      {
        name: 'hasThePropertyBeenOccupiedByYouAsYourMainResidenceForAtLeastTwoOutOfTheFiveYearsPriorToTheSale',
        label:
          'Has the property been occupied by you as your main residence for at least two out of the five years prior to the sale?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'ifNoHasTheSaleTakenPlaceDueToAChangeInYourPlaceOfEmploymentHealthOrUnforeseenCircumstances',
            label:
              'Has the sale taken place due to a change in your place of employment, health or unforeseen circumstances?',
            type: 'radio',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'no',
            dependencies: [
              {
                name: 'ifYesPleaseExplainTheCircumstances',
                label: 'Please explain the circumstances',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                predicate: (value) => value === 'yes',
                placeholder: 'Enter...',
              },
            ],
          },
        ],
      },
      {
        name: 'hasThePropertyBeenRentedForAnyPeriodBetweenDecember312008AndTheSaleDate',
        label:
          'Has the property been rented for any period between December-31-2008 and the sale date?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseGiveDetailsOfPeriodsRentedOut',
            label: 'Please give details of periods rented out',
            type: 'textarea',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter...',
          },
        ],
      },
      {
        name: 'isThePropertyInTheUs',
        label: 'Is the property in the US?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseUploadForm1099S',
            label: 'Please upload form 1099-S',
            type: 'upload',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
